var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIconTableau = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 18 18",
  width: "1em",
  height: "1em"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeMiterlimit: 10,
  clipPath: "url(#icon-tableau_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  strokeWidth: 2,
  d: "M9 6v6M6 9h6"
}), /*#__PURE__*/React.createElement("path", {
  d: "M2 8v2M1 9h2m13-1v2m-1-1h2m-7-7H8m1-1v2m1 13H8m1-1v2M4 2v4M2 4h4m-2 8v4m-2-2h4m8-12v4m-2-2h4m-2 8v4m-2-2h4"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "icon-tableau_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h18v18H0z"
})))));
export default SvgIconTableau;